import { render } from "./SkeletonControl.vue?vue&type=template&id=ccd20036&scoped=true"
const script = {}

import "./SkeletonControl.vue?vue&type=style&index=0&id=ccd20036&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd20036"]])

export default __exports__